import loadEmails from '@bingads-webui-campaign-legacy/inline-download-reports/load-emails';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import React, { useContext } from 'react';
import { EmailPicker } from './src/editor';

const Wrapper = (props) => {
  const { scope } = useContext(ScopeContext);
  const serverContext = useContext(ServerContext);

  const currentUserEmail = serverContext.CurrentUser.Email;
  const allUsersType = scope.values.aid ? 'Account' : 'Customer';

  return (
    <EmailPicker
      {...props}
      currentUserEmail={currentUserEmail}
      loadEmails={() => loadEmails({ allUsersType })}
    />
  );
};

export { Wrapper as EmailPicker };
